// Google Analytics Debug Utility
// Open browser console and run: window.debugGA()

export function debugGA() {
  console.log("=== Google Analytics Debug ===\n");

  // Check if gtag exists
  console.log("1. GA Script Status:");
  console.log(
    "   window.gtag exists:",
    typeof (window as any).gtag !== "undefined",
  );
  console.log(
    "   window.dataLayer exists:",
    typeof (window as any).dataLayer !== "undefined",
  );
  console.log("   dataLayer length:", (window as any).dataLayer?.length || 0);

  // Check cookie consent
  console.log("\n2. Cookie Consent Status:");
  const consentRaw = localStorage.getItem("cookie_consent");
  if (consentRaw) {
    try {
      const consent = JSON.parse(consentRaw);
      console.log("   Consent stored:", consent);
      console.log("   Analytics enabled:", consent.consent?.analytics);
    } catch (e) {
      console.log("   ERROR parsing consent:", e);
    }
  } else {
    console.log("   No consent found in localStorage");
  }

  // Check if GA scripts are loaded
  console.log("\n3. GA Scripts in DOM:");
  const scripts = document.querySelectorAll('script[src*="googletagmanager"]');
  console.log("   Scripts found:", scripts.length);
  scripts.forEach((script: any, i) => {
    console.log(`   [${i}]:`, script.src);
  });

  // Check dataLayer
  console.log("\n4. DataLayer Contents:");
  if ((window as any).dataLayer) {
    (window as any).dataLayer.forEach((item: any, i: number) => {
      console.log(`   [${i}]:`, item);
    });
  } else {
    console.log("   DataLayer not initialized");
  }

  console.log("\n=== Quick Fixes ===");
  console.log("• Accept all cookies:");
  console.log("  window.acceptAllCookies()");
  console.log("\n• Send test event:");
  console.log("  window.testGAEvent()");
  console.log("\n• Check again:");
  console.log("  window.debugGA()");
}

export function acceptAllCookies() {
  const consent = {
    consent: {
      essential: true,
      functional: true,
      analytics: true,
      marketing: true,
    },
    version: "1.0",
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem("cookie_consent", JSON.stringify(consent));
  console.log("✅ All cookies accepted!");
  console.log("🔄 Reloading page to apply changes...");
  setTimeout(() => window.location.reload(), 1000);
}

export function testGAEvent() {
  if ((window as any).gtag) {
    (window as any).gtag("event", "test_event", {
      event_category: "debug",
      event_label: "manual_test",
      value: 1,
    });
    console.log("✅ Test event sent to GA!");
    console.log(
      "Check Google Analytics Real-Time report to see if it appears.",
    );
  } else {
    console.error("❌ window.gtag is not available");
    console.log("GA may not be loaded yet. Try accepting cookies first:");
    console.log("  window.acceptAllCookies()");
  }
}

// Make available globally
if (typeof window !== "undefined") {
  (window as any).debugGA = debugGA;
  (window as any).acceptAllCookies = acceptAllCookies;
  (window as any).testGAEvent = testGAEvent;

  console.log("🔧 GA Debug tools loaded!");
  console.log("Run window.debugGA() in console to check GA status");
}
